import { Search, UnorderedSearchIndex } from 'js-search'

export default class SearchService {

  constructor () {
    this.dataSources = []
    this.initialized = false
  }

  addDataSource ({name, attributes}) {
    this.dataSources.push({
      name,
      attributes
    })
  }

  init () {
    this.dataSources = this.dataSources.map(dataSource => {
      const s = new Search('id')
      s.searchIndex = new UnorderedSearchIndex()
      s.addIndex('search')
      s.addDocuments(dataSource.attributes)
      return {
        name: dataSource.name,
        searchIndex: s
      }
    })
  }

  search (term) {
    if (!this.initialized) {
      this.init()
      this.initialized = true
    }
    return this.dataSources.map(dataSource => {
      return {
        name: dataSource.name,
        results: dataSource.searchIndex.search(term)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/attributePanel/services/search.js